export const NullCheck = data => {
  if (data === null) {
    return "";
  } else {
    return data;
  }
};

export default NullCheck;
